export default __webpack_public_path__ + "images/pages/quiz/clear-562a940be860559bf93c1945075f545d.svg";